
import { Component, Prop, Vue } from "nuxt-property-decorator";
import EsyCard from "~/components/atoms/sectioning/EsyCard.vue";
import EsyCardContent from "~/components/atoms/sectioning/EsyCardContent.vue";
import RouterLink from "~/components/atoms/text/RouterLink.vue";
import SummedRating from "~/components/molecules/display/ratings/SummedRating.vue";
import { Dealer } from "~/types/ApiEsyoil";

@Component({
  components: {
    EsyCard,
    EsyCardContent,
    RouterLink,
    SummedRating,
  },
})
export default class TopDealersList extends Vue {
  @Prop({ required: true }) private topDealers!: Dealer[];
  @Prop({ required: true }) private basePath!: string;
}
